import { useState } from 'react';
import { useMount } from 'ahooks';
import axios from 'axios';

export interface ExternalProvider {
  authenticationScheme: string;
  displayName: string;
}

export const useExternalProviders = (setLoading?: (loading: boolean) => void) => {
  const [externalProviders, setExternalProviders] = useState<ExternalProvider[]>([]);

  const loadExternalProviders = async () => {
    setLoading?.(true);
    try {
      const result = await axios.get<ExternalProvider[]>('/externalProviders');
      if (result?.status === 200 && Array.isArray(result.data)) {
        setExternalProviders(result.data);
      }
    } catch (e) {
      console.error('External Providers', e);
    } finally {
      setLoading?.(false);
    }
  };

  useMount(() => {
    loadExternalProviders();
  });

  return { externalProviders, loadExternalProviders };
};
